import type { LibraryConnection, OpdsFeed, OpdsEntry } from '../opds/types';

function buildParams(url: string, library?: LibraryConnection): URLSearchParams {
  const params = new URLSearchParams({ url });
  if (library?.auth) {
    params.set('username', library.auth.username);
    params.set('password', library.auth.password);
  }
  return params;
}

export async function fetchOpdsFeed(
  feedUrl: string,
  library?: LibraryConnection
): Promise<OpdsFeed> {
  const params = buildParams(feedUrl, library);
  const res = await fetch(`/api/opds/feed?${params}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to fetch feed: ${res.status} ${text}`);
  }
  const data = await res.json();
  return data.feed;
}

export async function fetchOpdsEntry(
  entryUrl: string,
  library?: LibraryConnection
): Promise<OpdsEntry> {
  const params = buildParams(entryUrl, library);
  params.set('entry', 'true');
  const res = await fetch(`/api/opds/feed?${params}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to fetch entry: ${res.status} ${text}`);
  }
  const data = await res.json();
  return data.entry;
}

export async function searchOpds(
  descUrl: string,
  query: string,
  library?: LibraryConnection
): Promise<{ feed: OpdsFeed; searchUrl?: string }> {
  const params = new URLSearchParams({ descUrl, query });
  if (library?.auth) {
    params.set('username', library.auth.username);
    params.set('password', library.auth.password);
  }
  const res = await fetch(`/api/opds/search?${params}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Search failed: ${res.status} ${text}`);
  }
  const data = await res.json();
  return { feed: data.feed, searchUrl: data.searchUrl };
}

export async function downloadBook(
  fileUrl: string,
  library?: LibraryConnection
): Promise<Blob> {
  const params = buildParams(fileUrl, library);
  const res = await fetch(`/api/opds/download?${params}`);
  if (!res.ok) {
    throw new Error(`Download failed: ${res.status}`);
  }
  return res.blob();
}

export function proxyImageUrl(
  imageUrl: string,
  library?: LibraryConnection
): string {
  const params = buildParams(imageUrl, library);
  return `/api/opds/image?${params}`;
}
